<template>
  <aside class="w-64 border-r bg-white transform transition-all duration-300 shadow-sm">
    <div class="p-4">
      <h2 class="text-lg font-semibold text-gray-800 mb-4">分类</h2>
      
      <nav class="space-y-1">
        <router-link 
          to="/notes" 
          class="block px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-200 hover:bg-gray-50"
          :class="!selectedCategory ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-50'"
          @click="selectCategory('')"
        >
          全部笔记
        </router-link>
        
          <router-link 
            v-for="category in categories" 
            :key="category.type"
            to="/notes" 
            class="block px-3 py-2 rounded-lg text-sm font-medium"
            :class="selectedCategory === category.type ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-50'"
            @click="selectCategory(category.type)"
          >
            {{ category.name }}
        </router-link>
      </nav>
      
      <h2 class="text-lg font-semibold text-gray-800 mt-8 mb-4">标签</h2>
      
      <div class="flex flex-wrap gap-2">
        <button 
          v-for="tag in tags" 
          :key="tag"
          @click="toggleTag(tag)"
          :class="[
            'px-2 py-1 rounded-full text-xs font-medium',
            selectedTags.includes(tag) 
              ? 'bg-blue-100 text-blue-800' 
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          ]"
        >
          {{ tag.name }}
        </button>
      </div>
    </div>
  </aside>
</template>

<script>
import { computed, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  name: 'AppSidebar',
  setup() {
    const store = useStore()
    const router = useRouter()
    
    const categories = computed(() => store.getters['notes/allCategories'])
    const tags = computed(() => store.getters['tags/allTags'])
    const isAuthenticated = computed(() => store.getters['user/isAuthenticated'])
    
    const selectedCategory = ref('')
    const selectedTags = ref([])
    
    onMounted(async () => {
      if (isAuthenticated.value) {
        await store.dispatch('tags/fetchTags')
      }
    })
    
    const selectCategory = (category) => {
      selectedCategory.value = category
      // 这里可以添加过滤逻辑或者通过 URL 参数传递
    }
    
    const toggleTag = (tag) => {
      // 跳转到笔记列表页面，并带上tag参数
      router.push({
        path: '/notes',
        query: { tag: tag.id }
      })
    }
    
    return {
      categories,
      tags,
      selectedCategory,
      selectedTags,
      selectCategory,
      toggleTag
    }
  }
}
</script> 